import { library } from "@fortawesome/fontawesome-svg-core";
import CommunityTalkLoader from "@/modules/loaders/communityTalkLoader";
import TrackingLoader from "./modules/loaders/trackingLoader";
require("@/assets/style/global.scss");
import ResetCssLoader from "./modules/loaders/resetCssLoader";

// 使用するFontAwesomeアイコン
// ここでインポートしたFontAwesomeアイコンしか使用できないので、使用したいアイコンが増えた場合はここに追加すること
import { faMessage } from "@fortawesome/free-regular-svg-icons";
import { faMagnifyingGlass, faAngleRight, faAngleDown, faThumbsUp, faPaperPlane, faCircleCheck, faImage } from "@fortawesome/free-solid-svg-icons";

// 使いたいFontAwesomeアイコンを登録
library.add(faMessage);
library.add(faMagnifyingGlass);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faThumbsUp);
library.add(faPaperPlane);
library.add(faCircleCheck);
library.add(faImage);

function main() {
	// トラッキング処理を入れこむ
	TrackingLoader.trackingLoad();
	// リセットCSS処理を入れ込む
	ResetCssLoader.resetCssLoad();

	// コンポーネントローダーを起動（現状1つのみ）
	CommunityTalkLoader.load();
}

(function () {
	if (document.readyState == "loading") {
		document.addEventListener("DOMContentLoaded", main);
	} else {
		main();
	}
})();
